/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

import CustomInput from '~/components/layout/CustomInput';

import CustomButton from '~/components/layout/CustomButton';

export const Container = styled.div`
  padding: 70px;

  @media (max-width: 959px) {
    padding: 20px;
  }
`;

export const InputCond = styled(CustomInput)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const InputDoc = styled(CustomInput)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonNext = styled(CustomButton)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonBack = styled(CustomButton)`
  margin-top: 16px;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonText = styled.p`  
  display: flex;
  justify-content: center;
  margin-right: 42px;
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 37px;
  display: flex;
  align-items: center;
  color: #0b24fb;
`;

export const Text = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 29px;
  color: #7a7a7a;
  max-width: 538px;
`;

export const FormContainer = styled.div`
  margin-top: 57px;
`;

export const WrapSearchDocument = styled.div`
  width: 448px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
  color: #0b24fb;
  margin-top: 5px;
  margin-bottom: 16px;

  div {
    cursor: pointer;
  }

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const SearchDocumentText = styled.span`
  text-decoration-line: underline;
  cursor: pointer;
`;

export const SearchDocumentIcon = styled.div`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background: #97f8fb;
  border-radius: 50%;
  font-weight: 500;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;

  button {
    + button {
      margin-top: 16px;
    }
  }
`;
